import { render, staticRenderFns } from "./textboxbuttons.vue?vue&type=template&id=1e8843af"
import script from "./textboxbuttons.vue?vue&type=script&lang=js"
export * from "./textboxbuttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports